import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo, forwardRef } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import useLegacyProps from '../../hooks/useLegacyProps.js';

var _excluded = ["children", "color", "size", "theme"];
var _templateObject;
var StyledLink = styled('a')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  text-decoration: none;\n  text-align: left;\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n    text-shadow: 0.75px 0 0 currentColor \n    transition: 0.3s;\n  }\n"])), function (_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    theme = _ref.theme;
  return theme.fontSize[size];
}, function (_ref2) {
  var color = _ref2.color,
    theme = _ref2.theme;
  return !!color ? theme.palette[color] : theme.link.color;
});
var Link = function Link(_ref3, ref) {
  var children = _ref3.children,
    color = _ref3.color,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? 'medium' : _ref3$size,
    _ref3$theme = _ref3.theme,
    theme = _ref3$theme === void 0 ? themes.publicSite : _ref3$theme,
    rest = _objectWithoutProperties(_ref3, _excluded);
  var _useLegacyProps = useLegacyProps(rest),
    className = _useLegacyProps.className,
    style = _useLegacyProps.style;
  return /*#__PURE__*/React.createElement(StyledLink, _extends({
    color: color,
    ref: ref,
    size: size,
    theme: theme,
    className: className,
    style: style
  }, rest), children);
};
var _Link = withDefaultTheme( /*#__PURE__*/memo( /*#__PURE__*/forwardRef(Link)));

export default _Link;
export { Link };
